export const DRAFT_CHECKLIST_URL =
    'https://jb-content.s3.amazonaws.com/Carebug-Live/files/JBE-Take-Action-Checklist-20220829.pdf';

export const INTERCOM_TARGET_PREFIX = 'updateChallenge';
